<nav class="navbar navbar-expand-lg bg-body-tertiary sticky-top">
    <div class="container">
        <a class="navbar-brand inter fw-semibold" [routerLink]="['/']">
            <img src="assets/bewell.svg" alt="Bewell Corporation" class="logo">
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0 gap-5">
            <li class="nav-item">
                <a class="nav-link inter fs-6 fw-semibold" aria-current="page" href="https://shop.bewell.com.ph">Shop</a>
            </li>
            <li class="nav-item">
                <a class="nav-link inter fs-6 fw-semibold" [routerLink]="['/products']">Products</a>
            </li>
            <li class="nav-item">
                <a class="nav-link inter fs-6 fw-semibold" [routerLink]="['/articles', 3, 1]">Articles</a>
            </li>
            <li class="nav-item">
                <a class="nav-link inter fs-6 fw-semibold" [routerLink]="['/careers']">Careers</a>
            </li>
            <li class="nav-item">
                <a class="nav-link inter fs-6 fw-semibold" [routerLink]="['/contacts']">Contacts</a>
            </li>
        </ul>
        </div>
    </div>
</nav>
